import '../assets/NcUserBubble-tSs2XTDQ.css';
import { createElementBlock, openBlock, renderSlot, resolveComponent, createBlock, resolveDynamicComponent, withCtx, mergeProps, createVNode, createElementVNode, createCommentVNode, normalizeStyle, toDisplayString, warn } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
import { N as NcAvatar } from "./NcAvatar-CSk-1oFe.mjs";
import { N as NcPopover } from "./NcPopover-MsWUAvsI.mjs";
import { RouterLink } from "vue-router";
const _sfc_main$1 = {
  name: "NcUserBubbleDiv"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "trigger")
  ]);
}
const NcUserBubbleDiv = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const _sfc_main = {
  name: "NcUserBubble",
  components: {
    NcAvatar,
    NcPopover,
    NcUserBubbleDiv
  },
  props: {
    /**
     * Override generated avatar, can be an url or an icon class
     */
    avatarImage: {
      type: String,
      default: void 0
    },
    /**
     * Provide the user id if this is a user
     */
    user: {
      type: String,
      default: void 0
    },
    /**
     * Displayed label
     */
    displayName: {
      type: String,
      default: void 0
    },
    /**
     * Whether or not to display the user-status
     */
    showUserStatus: {
      type: Boolean,
      default: false
    },
    /**
     * Define the whole bubble as a link
     */
    url: {
      type: String,
      default: void 0,
      validator: (url) => {
        try {
          url = new URL(url, url?.startsWith?.("/") ? window.location.href : void 0);
          return !!url;
        } catch (error) {
          return false;
        }
      }
    },
    /**
     * Use bubble as a router-link for in-app navigation
     */
    to: {
      type: [String, Object],
      default: void 0
    },
    /**
     * Default popover state. Requires the UserBubble
     * to have some content to render inside the popover
     */
    open: {
      type: Boolean,
      default: false
    },
    /**
     * Use the primary colour
     */
    primary: {
      type: Boolean,
      default: false
    },
    /**
     * This is the height of the component
     */
    size: {
      type: Number,
      default: 20
    },
    /**
     * This is the margin of the avatar (size - margin = avatar size)
     */
    margin: {
      type: Number,
      default: 2
    }
  },
  emits: [
    "click",
    "update:open"
  ],
  computed: {
    /**
     * Is the provided avatar url valid or not
     *
     * @return {boolean}
     */
    isAvatarUrl() {
      if (!this.avatarImage) {
        return false;
      }
      try {
        const url = new URL(this.avatarImage);
        return !!url;
      } catch (error) {
        return false;
      }
    },
    /**
     * Do we have a custom avatar or not
     *
     * @return {boolean}
     */
    isCustomAvatar() {
      return !!this.avatarImage;
    },
    hasUrl() {
      return this.url && this.url.trim() !== "";
    },
    isLinkComponent() {
      if (this.hasUrl) {
        return "a";
      } else if (this.to) {
        return RouterLink;
      } else {
        return "div";
      }
    },
    styles() {
      return {
        content: {
          height: this.size + "px",
          lineHeight: this.size + "px",
          borderRadius: this.size / 2 + "px"
        },
        avatar: {
          marginInlineStart: this.margin + "px"
        }
      };
    }
  },
  mounted() {
    if (!this.displayName && !this.user) {
      warn("[NcUserBubble] At least `displayName` or `user` property should be set.");
    }
  },
  methods: {
    onOpenChange(state) {
      this.$emit("update:open", state);
    },
    /**
     * Catch and forward click event to parent
     *
     * @param {Event} event the click event
     */
    onClick(event) {
      this.$emit("click", event);
    }
  }
};
const _hoisted_1 = { class: "user-bubble__name" };
const _hoisted_2 = {
  key: 0,
  class: "user-bubble__secondary"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcAvatar = resolveComponent("NcAvatar");
  return openBlock(), createBlock(resolveDynamicComponent(!!_ctx.$slots.default ? "NcPopover" : "NcUserBubbleDiv"), {
    trigger: "hover focus",
    shown: $props.open,
    class: "user-bubble__wrapper",
    "onUpdate:open": $options.onOpenChange
  }, {
    trigger: withCtx(({ attrs }) => [
      (openBlock(), createBlock(resolveDynamicComponent($options.isLinkComponent), mergeProps({
        class: ["user-bubble__content", { "user-bubble__content--primary": $props.primary }],
        style: $options.styles.content,
        to: $props.to,
        href: $options.hasUrl ? $props.url : null
      }, attrs, { onClick: $options.onClick }), {
        default: withCtx(() => [
          createVNode(_component_NcAvatar, {
            url: $options.isCustomAvatar && $options.isAvatarUrl ? $props.avatarImage : void 0,
            "icon-class": $options.isCustomAvatar && !$options.isAvatarUrl ? $props.avatarImage : void 0,
            user: $props.user,
            "display-name": $props.displayName,
            size: $props.size - $props.margin * 2,
            style: normalizeStyle($options.styles.avatar),
            "disable-tooltip": true,
            "disable-menu": true,
            "show-user-status": $props.showUserStatus,
            class: "user-bubble__avatar"
          }, null, 8, ["url", "icon-class", "user", "display-name", "size", "style", "show-user-status"]),
          createElementVNode("span", _hoisted_1, toDisplayString($props.displayName || $props.user), 1),
          !!_ctx.$slots.name ? (openBlock(), createElementBlock("span", _hoisted_2, [
            renderSlot(_ctx.$slots, "name", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ]),
        _: 2
      }, 1040, ["style", "to", "href", "class", "onClick"]))
    ]),
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 40, ["shown", "onUpdate:open"]);
}
const NcUserBubble = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-6e4010a7"]]);
export {
  NcUserBubble as N
};
//# sourceMappingURL=NcUserBubble-Csot0WLv.mjs.map
